import React, { useState } from 'react';
import MainLayout from '../Layouts/MainLayout';
import ChalanDetails from './ChalanDetails';

function ChalanDetailsContainer({ isEdit }) {
  return (
    <MainLayout
      navTitle={'Chalan List Details'}
      navSubTitle={'Welcome to Classy Vouge'}
    >
      <ChalanDetails isEdit={isEdit} />
    </MainLayout>
  );
}

export default ChalanDetailsContainer;
